import {UrlObject} from "url";

const patientAppHrefRegex = /(carbonhealth\.com|^)\/patients/;

export const shouldAllowReferrer = (url: string | UrlObject | unknown) =>
  typeof url === "string" ? patientAppHrefRegex.test(url) : false;
